module.exports = __webpack_public_path__ + "img/icon-quote.asset.5fcc3df6.svg";